import React, { useState, useEffect, useRef, useCallback, useMemo  } from 'react';
import 'devextreme/data/odata/store';
import {LoadPanel as LoadingPanel} from 'devextreme-react/load-panel';
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  Editing,
  Texts,
  Button,
  HeaderFilter,
  SearchPanel,
  RequiredRule,
  FilterPanel
} from 'devextreme-react/data-grid';
import { Popup as ConfirmDeletePopUp } from 'devextreme-react/popup';
import { Form  as Form2, GroupItem, SimpleItem, Label, ButtonItem, PatternRule} from 'devextreme-react/form';
import {Button as SelectButton} from 'devextreme-react/button';
import TenantService from "../../api/tenant.service";
import AssetsService from "../../api/assets.service";
import Toast from 'components/Toast';
import DOMPurify from 'dompurify';
import './assets.css';
import { ScrollView } from 'devextreme-react/scroll-view';
import AssetTypeCreate from './assetType/assetTypeCreate';
import {Tooltip} from 'devextreme-react';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer';

export default function Types() {
  const formRef = useRef(null);
  const [isFormValid, setIsFormValid] = useState(true); // default true
  const scrollViewRef = useRef(null);
  const [data, setData] = useState([])
  const [attributeData, setAttributeData] = useState([])
  const [name, setName] = useState(null)
  const [loadingText, setloadingText] = useState('Loading...');
  const tenant = TenantService.getTenant()
  const [showEditTypeDrawer, setShowEditTypeDrawer] = useState(false)
  const [showDeletePopup, setShowDeletePopup] = useState(false)
  const [deleteAttribName, setDeleteAttribName] = useState(null)
  const dropDataGridRef = useRef()
  const formData = useMemo(() => ({ name: name, Attributes: attributeData }), [name, attributeData]);
  const [attributeLength, setAttributeLength] = useState(0)
  const [originalAttributes, setOriginalAttributes] = useState([]);
  const [originalRawAttributes, setOriginalRawAttributes] = useState([]);
  const [editedAttributes, setEditedAttributes] = useState([]);
  const [newlyAddedAttributes, setNewlyAddedAttributes] = useState([]);
  const [isAttribEmpty, setIsAttribEmpty] = useState(false)
  const [loading, setLoading] = useState(false);
  const [showCreatePopup, setShowCreatePopup] = useState(false);
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000,
  });
  const [editingRow, setEditingRow] = useState(null);
  const noSpecialCharsPattern = /^[a-zA-Z0-9\s]*$/;
  const [prevData, setPrevData] = useState(null);
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const [newType, setNewType] = useState('');
  const [newAttributes, setNewAttributes] = useState(['']);
  const [isCreateFormValid, setIsCreateFormValid] = useState(true);
  const createFormRef = useRef(null);
  function getData() {
    AssetsService.getAssetTenantAttributeTypes().then((value) => {
      let response=value.data
      setData(response.data)
      if (response?.data?.length === 0){
        setloadingText('No Data')
      }
    })
  }

  function handleAddAssetType(e){
    setShowCreatePopup(false)
    setLoading(true)
    AssetsService.addAssetType(e.type, tenant, e.attributes).then((response) => {
        getData()
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: response?.status===200 ? 'success' : 'error', 
          status: response?.data?.status ? response?.data?.status : response.status,
          message: response?.data?.message ? response.data.message : response.message,
        });
      }).finally(() => {
        setLoading(false); // Stop loader after response (success or error)
      });
    
  }

  function onRowRemoved(e) {
    AssetsService.deleteAssetType(e.data.id).then((response) => {
      if(response.status === 200){
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: response.status===200 ? 'success' : 'error',
          status: response?.data?.status ? response.data.status : response?.status,
          message: response?.data?.message ? response.data.message : response?.message,
        });
      }else {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error', 
          status: 400,
          message: 'The Asset Type is being used by one or more assets. Please delete those assets first.'
        });
      }  
      getData()
    })
  }

  useEffect(() => {
    getData()
  }, []);

  async function openEditPopUp(e){
    await setEditingRow(e.row.data.id);
    setShowEditTypeDrawer(true)
    await setName(e.row.data.name)
    if (e.row.data.attributes.length && e.row.data.attributes.length > 0){
      setAttributeData(e.row.data.attributes.map((item)=> item.display))
      setAttributeLength(e.row.data.attributes.length)
      setOriginalAttributes(e.row.data.attributes.map((item)=> item.display))
      setOriginalRawAttributes(e.row.data.attributes)
      setPrevData({ name: e.row.data.name, Attributes: e.row.data.attributes.map((item)=> item.display) });
    } else {
      setAttributeData([])
      setAttributeLength(0)
      setOriginalAttributes([])
      setOriginalRawAttributes([])
      setPrevData({ name: e.row.data.name, Attributes: [] });
    }
    await setEditingRow(e.row.data.id);
  }



  const valueChangeAttribute = (e) => {
    const formInstance = formRef.current?.instance();
    const validationResult = formInstance.validate();
    console.log('validation result: ', validationResult);
    
    if (!validationResult.isValid) {
      console.log('FORM VALID 123: ', validationResult.isValid);
      setIsFormValid(validationResult.isValid)
      // Validation failed, show error and stop submission
      return;
    } else {
      setIsFormValid(validationResult.isValid)
    }
    // Update attributeData immutably
    setAttributeData((prev) => {
      const updated = [...prev];
      // e.value is the new value for the attribute (for devextreme forms, it may be e.value or e.data)
      // Try both, fallback to e.data if e.value is undefined
      updated[e.index] = e.value !== undefined ? e.value : e.data;
      return updated;
    });
  };

  function onHidingEditTypeDrawer(){
    setIsAttribEmpty(false)
    setAttributeData([])
    setOriginalAttributes([])
    setOriginalRawAttributes([])
    setEditedAttributes([])
    setNewlyAddedAttributes([])
    setShowEditTypeDrawer(false)
  }

  function onHidingDeleteAttributePopup(e){
    setDeleteAttribName(null)
    setShowDeletePopup(false)
  }

  async function deleteAssetAttribute(e){
    setLoading(true)
    await AssetsService.deleteAssetAttributeType(editingRow, deleteAttribName).then((response) => {
      if (response.status === 200){
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: response?.status === 200 ? 'success' : 'error', 
          status: response?.data?.status ? response?.data?.status : response.status,
          message: response?.data?.message ? response.data.message : response.message,
        });
        const attributes = response.data && response.data.data[0] && response.data.data[0].attributes
        if (attributes && attributes.length){
          setAttributeData(attributes.map((item)=> item.display))
          setAttributeLength(attributes.length)
          setOriginalAttributes(attributes.map((item)=> item.display))
          setOriginalRawAttributes(attributes)
        } else {
          setAttributeData([])
          setAttributeLength(0)
          setOriginalAttributes([])
          setOriginalRawAttributes([])
        }
        setShowDeletePopup(false)
      } else {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'error',
          status: 400,
          message: 'Something went wrong. Please try again later.'
        });
      }
      setLoading(false)
    })  
  }

  function manageContentScroll(){
    if (scrollViewRef.current) {
      const scrollViewInstance = scrollViewRef.current.instance();
      scrollViewInstance.scrollTo({ top: scrollViewInstance.scrollHeight() });
    }
  }

  function saveInfo(updatedName){
    console.log('Save button clicked');
    // Validate the form before proceeding
    const formInstance = formRef.current?.instance();
    const validationResult = formInstance?.validate?.();
    if (validationResult && !validationResult.isValid) {
      setIsFormValid(false);
      return;
    }
    setIsFormValid(true);
    if (isFormValid) {
    console.log('HERE 208');
    setLoading(true)
    setShowEditTypeDrawer(false)
    let shouldBreak = false;
    setIsAttribEmpty(false)
    const updatedAttributes = attributeData.map((editedAttribute, index) => {
        const originalAttribute = originalAttributes[index];
        if (index < attributeLength) {
          // Check if the attribute has been edited
          if (editedAttribute !== originalAttribute) {
            return {
              action: 'update',
              index,
              oldValue: originalAttribute,
              newValue: editedAttribute,
            };
          }
        } else {
          // Newly added attribute
          console.log("editedAttribute",editedAttribute)
          if(editedAttribute !== ""){
            return {
              action: 'add',
              index,
              value: editedAttribute,
            };
          }
          
        }
  
        return null;
      }).filter(Boolean);
      console.log('Update :', updatedAttributes);
      console.log('Original Attributes :', originalRawAttributes);
      const finalData = updatedAttributes.map((item) => {
        if (item.action === 'update') {
          const matchingElement = originalRawAttributes.find(
            (element) => element.display === item.oldValue
          );
          if (matchingElement) {
            item.name = matchingElement.attributeName;
          }
        }
        return item;
      });
      
      if (finalData.length === 0 && updatedName !== undefined){
        setLoading(true)
        AssetsService.editAssetType(name, editingRow).then((response) => {
          console.log('editAssetType API response:', response);
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: response?.status===200 ? 'success' : 'error', 
            status: response?.data?.status ? response?.data?.status : response.status,
            message: response?.data?.message ? response.data.message : response.message,
          });
          getData();
          setShowEditTypeDrawer(false);
          setLoading(false);
        })
      } else if (finalData.length > 0) {
        
        // setOriginalName(name)
        for (const d in finalData){
          if (finalData[d].action === 'update' && finalData[d].newValue === ''){
            setIsAttribEmpty(true)
            shouldBreak = true;
            break
          } else if (finalData[d].action === 'add' && finalData[d].value === ''){
            setIsAttribEmpty(true);
            shouldBreak = true;
            break
          }
        }
        console.log('shouldBreak: ', shouldBreak);
        if (!shouldBreak) {
          setLoading(true)
          AssetsService.editAssetAttributeType(editingRow, name, finalData).then((response) => {
            if (response.status === 200){
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: response?.status===200 ? 'success' : 'error', 
                status: response?.data?.status ? response?.data?.status : response.status,
                message: response?.data?.message ? response.data.message : response.message,
              });
              getData();
              setShowEditTypeDrawer(false);
              setLoading(false);
            } else {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'error', 
                status: 400,
                message: response?.data?.message ? response.data.message : response.message,
              });
              setLoading(false)
            }
          })

        }
      }
    } else {
      onHidingEditTypeDrawer()
    }
  }

  const confirmDeleteAttribute = (index, isExistingAttribute) => {
    if (isExistingAttribute) {
      const attribute = attributeData[index];
      setDeleteAttribName(attribute)
      setShowDeletePopup(true)
    }
  };

  const generateNewAttributeOptions = useCallback(
    (index) => {
      const isExistingAttribute = index < attributeLength;
      return{
        buttons: [
          {
            name: 'trash',
            location: 'after',
            options: {
              stylingMode: 'text',
              icon: 'trash',
              visible: true,
              onClick: () => {
                if (isExistingAttribute){
                  confirmDeleteAttribute(index, isExistingAttribute);
                  return true;
                }
                // If the attribute being deleted is from the originalAttributes, update the originalAttributes state
                if (index < attributeLength) {
                  setOriginalAttributes((prevAttributes) =>
                    prevAttributes.slice(0, index).concat(prevAttributes.slice(index + 1))
                  );
                }
                // If the attribute being deleted is from the editedAttributes, update the editedAttributes state
                if (index < editedAttributes.length) {
                  setEditedAttributes((prevAttributes) =>
                    prevAttributes.slice(0, index).concat(prevAttributes.slice(index + 1))
                  );
                }
                // If the attribute being deleted is from the newlyAddedAttributes, update the newlyAddedAttributes state
                if (index >= attributeLength && index < attributeLength + newlyAddedAttributes.length) {
                  setNewlyAddedAttributes((prevAttributes) =>
                    prevAttributes.slice(0, index - attributeLength).concat(prevAttributes.slice(index - attributeLength + 1))
                  );
                }
                // Update the attributeData state
                setAttributeData((prevAttributes) => prevAttributes.slice(0, index).concat(prevAttributes.slice(index + 1)));
              },
            },
          },
        ],
      }
      
    },
    [attributeData, attributeLength, editedAttributes, newlyAddedAttributes],
  );
  

  const AttributeOptions = useMemo(() => {
    const options = [];
    for (let i = 0; i < attributeData.length; i += 1) {
      options.push(generateNewAttributeOptions(i));
    }
    return options;
  }, [attributeData, generateNewAttributeOptions]);
  const AttributeButtonOptions = useMemo(
    () => ({
      icon: 'add',
      text: 'Add Attribute',
      color: '#FFFFFF',
      elementAttr: {
        style: 'background-color: #D71109; color: #FFFFFF', // Add inline styles
        class: 'add-atrib-btn',
      },
      onClick: () => {
        setAttributeData((prevAttributes) => [...prevAttributes, '']);
        manageContentScroll();
      },
    }),
    [],
  );

  const handleAddDrawerOpen = () => {
    setNewType('');
    setNewAttributes(['']);
    setShowCreateDrawer(true);
  };
  const handleAddDrawerClose = () => {
    setShowCreateDrawer(false);
  };
  const handleAddAttribute = () => {
    setNewAttributes((prev) => [...prev, '']);
  };
  const handleRemoveAttribute = (index) => {
    setNewAttributes((prev) => prev.filter((_, i) => i !== index));
  };
  const handleCreateSave = () => {
    const formInstance = createFormRef.current?.instance();
    const validationResult = formInstance?.validate?.();
    if (validationResult && !validationResult.isValid) {
      setIsCreateFormValid(false);
      return;
    }
    setIsCreateFormValid(true);
    const filteredAttributes = newAttributes.filter((attr) => attr.trim() !== '');
    const formData = {
      type: newType,
      attributes: filteredAttributes,
    };
    handleAddAssetType(formData);
    setShowCreateDrawer(false);
  };

  const onCustomButtonClick = () => {
    handleAddDrawerOpen();
  };


  return (
    <>
    <div className='headerHeadingPage'>
		  <div className='pageFullWidthEvents'>
        <h5 className='marginZeroEvents'>
          <b>Asset Types</b>
        </h5>
      <Toast
        setParentToastConfig={setToastConfig}
        toastBody={toastConfig}
      />
      <LoadingPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={loading}
        showIndicator={true}
        showPane={true}
        shading={true}
        hideOnOutsideClick={false}
      />
      <div className='headerHeadingPage'>
            <div className='pageFullWidthEvents'>
                <div className='add_asset_col'>
                    <i className="entity-group-add dx-icon-add download_btn" id="addAssetTypeBtn" onClick={onCustomButtonClick} style={{ "fontSize": "24px" }}></i>
                    <Tooltip
                      target="#addAssetTypeBtn"
                      showEvent="mouseenter"
                      hideEvent="mouseleave"
                      position="bottom"
                      // visible={true}
                    >
                      <div className="custom-tooltip">Add an Asset Type</div>
                    </Tooltip>
                </div>
            </div>
        </div>
      <DataGrid
        // onOptionChanged={optionChange}
        noDataText={loadingText}
        ref={dropDataGridRef}
        showColumnLines={false}
        showRowLines={true}
        // onRowInserted={onRowInserted}
        onRowRemoved={onRowRemoved}
        allowColumnResizing={true}
        height={'calc(100vh - 102px)'}
        onColumnsChanging={function (e) {
          if(e.component?.getDataSource()?._totalCount <= 0 && data.length > 0){
            setloadingText('No Data');
          }
        }}
        dataSource={data}>
        <Paging enabled={false} />
        <Editing
          allowUpdating={false}
          allowDeleting={true}
          allowAdding={false}
          use-icons={true}
          mode="popup"
          texts={{
            // addRow: 'Add an Asset Type',
            confirmDeleteMessage: 'Are you sure you want to delete this Asset Type?'
          }}
        >
          <Texts
            confirmDeleteMessage="Are you sure you want to delete this Asset Type?"
          />
        </Editing>
        <FilterRow visible="true" apply-filter="true" />
        <HeaderFilter visible="showHeaderFilter" />
        <SearchPanel visible="true" width="240" placeholder="Search..." />
        <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
        <Column
          dataField={DOMPurify.sanitize('name')}
          caption={"Asset Type Name"}
          width={190}
          hidingPriority={8}
        >
          <RequiredRule />
        </Column>
        <Column
          dataField={DOMPurify.sanitize('type')}
          caption={''}
          allowSorting={false}
          allowFiltering={false}
        >
        </Column>
        <Column type="buttons">
          <Button name="edit" onClick={openEditPopUp} visible={true} icon={"edit"} />
          <Button name="delete" />
        </Column>
      </DataGrid>
      <SlidingDrawer
        isOpen={showEditTypeDrawer}
        onClose={onHidingEditTypeDrawer}
        title={"Edit Asset Type"}
        handleSave={saveInfo}
        formData={formData}
        prevData={prevData}
      >
        <div>
          <ScrollView  showScrollbar='always' ref={scrollViewRef}>
            <Form2 id="form"
              ref={formRef}
              // Remove onFieldDataChanged
            >
              <GroupItem>
                <SimpleItem
                  dataField="name"
                  editorType="dxTextBox"
                  editorOptions={{
                    value: name || "",
                    onValueChanged: (e) => setName(e.value),
                    validationMessageMode: "always",
                    valueChangeEvent: 'input'
                  }}
                >
                  <Label text="Asset Type Name" />
                  <RequiredRule message="Asset Type Name is required" />
                </SimpleItem>
              </GroupItem>
              <GroupItem
                caption="Attributes"
                name="attributes-container"
              >
                <GroupItem name="attributes">
                  {AttributeOptions.length > 0 ? (
                    AttributeOptions.map((attribute, index) => (
                      <SimpleItem
                        key={`Attributes${index}`}
                        dataField={`Attributes[${index}]`}
                        editorType="dxTextBox"
                        editorOptions={{
                          value: attributeData[index] || "",
                          valueChangeEvent: 'input',
                          onValueChanged: (e) => {
                            setAttributeData((prev) => {
                              const updated = [...prev];
                              updated[index] = e.value;
                              return updated;
                            });
                          },
                        }}
                      >
                        <Label text={`Attribute ${index + 1}`} />
                        <PatternRule
                          message={'Do not use special characters like \\,/, ", @, # etc.'}
                          pattern={noSpecialCharsPattern}
                        />
                      </SimpleItem>
                    ))
                  ) : (
                    <SimpleItem
                      dataField="placeholder"
                      visible={false}
                    />
                  )}
                </GroupItem>
                <ButtonItem
                  horizontalAlignment="left"
                  buttonOptions={AttributeButtonOptions}
                ></ButtonItem>
              </GroupItem>
            </Form2>
          </ScrollView>
        </div>
        <div style={{display: isAttribEmpty ? 'block' : 'none' }} className='editAttribute-setNote'>Error: Attribute value cannot be empty.</div>
      </SlidingDrawer>
      <ConfirmDeletePopUp
        visible={showDeletePopup}
        // onHiding={hideDeletePopup}
        title={`Delete Asset Attribute - ${deleteAttribName}`}
        width={500}
        height={300}
      >
        Are you sure you want to delete the attribute <b>{deleteAttribName}</b>?
        <br/>
        <br/>
        Note: This action cannot be undone.
        <div className='movePopup'>
            <SelectButton className='movePopupSaveBtn' onClick={deleteAssetAttribute} style={{ marginRight:"5%"}}>Yes</SelectButton>
            <SelectButton className='movePopupSaveBtn' onClick={onHidingDeleteAttributePopup} >No</SelectButton>
        </div>
      </ConfirmDeletePopUp>
      <SlidingDrawer
        isOpen={showCreateDrawer}
        onClose={handleAddDrawerClose}
        title={"Add Asset Type"}
        handleSave={handleCreateSave}
        formData={{ type: newType, attributes: newAttributes }}
        prevData={{ type: '', attributes: [''] }}
      >
        <div style={{height: "100%"}}>
          <ScrollView height={"100%"} showScrollbar='always'>
            <Form2 id="create-form" ref={createFormRef}>
              <GroupItem>
                <SimpleItem
                  dataField="type"
                  editorType="dxTextBox"
                  editorOptions={{
                    value: newType,
                    valueChangeEvent: 'input',
                    onValueChanged: (e) => setNewType(e.value),
                    validationMessageMode: "always",
                  }}
                >
                  <Label text="Asset Type Name" />
                  <RequiredRule message="Asset Type Name is required" />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="Attributes">
                {newAttributes.map((attr, index) => (
                  <SimpleItem
                    key={`newAttribute${index}`}
                    dataField={`attributes[${index}]`}
                    editorType="dxTextBox"
                    editorOptions={{
                      value: attr,
                      onValueChanged: (e) => {
                        setNewAttributes((prev) => {
                          const updated = [...prev];
                          updated[index] = e.value;
                          return updated;
                        });
                      },
                      buttons: [
                        {
                          name: 'trash',
                          location: 'after',
                          options: {
                            stylingMode: 'text',
                            icon: 'trash',
                            onClick: () => handleRemoveAttribute(index),
                          },
                        },
                      ],
                    }}
                  >
                    <Label text={`Attribute ${index + 1}`} />
                    <PatternRule
                      message={'Do not use special characters like \\,/, ", @, # etc.'}
                      pattern={noSpecialCharsPattern}
                    />
                  </SimpleItem>
                ))}
                <ButtonItem
                  horizontalAlignment="left"
                  buttonOptions={{
                    icon: 'add',
                    text: 'Add Attribute',
                    elementAttr: {
                      style: 'background-color: #D71109; color: #FFFFFF',
                      class: 'add-atrib-btn',
                    },
                    onClick: handleAddAttribute,
                  }}
                />
              </GroupItem>
            </Form2>
          </ScrollView>
        </div>
      </SlidingDrawer>
    </div>
    </div>
    </>
  );
}